/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { userService } from '../../../service/plateServices';
import AlertModal from '../../../widgets/alertModal';
import CustomToast from '../../../widgets/toaster';
import { AddExceptionModel, ScanAreaModel } from './models';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CustomLoader from '../../../widgets/loader/loader';



interface AddExceptionProps {
  showModel: boolean;
  setShowModel: () => void;
  setRefreshPage?: (() => void) | undefined;
  isPlateSampling?: boolean;
  isRawMaterialTest?: boolean;
}

const AddException: React.FC<AddExceptionProps> = ({
  showModel,
  setShowModel,
  setRefreshPage,
  isPlateSampling,
  isRawMaterialTest,
}) => {

  const { t } = useTranslation();

  const [showAddExceptionAlert, setShowAddExceptionAlert] = useState(false)
  const [showPlateSamplingAlert, setPlateSamplingAlert] = useState(false)
  const [showRawMaterialAlert, setRawMaterialAlert] = useState(false)
  const [plateBySerielNo, setPlateBySerielNo] = useState<Array<any>>([]);
  const [exceptionReasons, setExceptionReasons] = useState<Array<any>>([]);
  const [samleTestType, setSampleTestType] = useState<Array<any>>([]);
  const [rawMaterialType, setRawMaterialType] = useState<Array<any>>([]);
  const [useEffectRequired, setUseEffectRequired] = useState(false);
  const [addExceptionData, setAddExceptionData] = useState({
    remarks: "",
    reason_id: "",
    other_reason: "",
    user_id: 0,
    area_id: "",
    subCategory_id: ""
  });
  const [rawMaterialSub, setRawMaterialSub] = useState<Array<any>>([]);
  const [userId, setUserId] = useState<number>(0);
  const [authToken, setAuthToken] = useState("")
  const [authUserID, setAuthUserID] = useState("")
  interface Errors {
    remarks?: string;
    reason_id?: string;
    other_reason?: string;
    scan_plate?: string;
    subCategory_id?: string;

  }
  const [errors, setErrors] = useState<Errors>({})
  const [webcamResult, setWebCamResult] = useState<string | null>(null);
  const [showScan, setShowScan] = useState(false);
  const [stream, setStream] = useState(false);
  const [showToast, setShowToast] = useState(false)
  const [toastMessage, setToastMessage] = useState("")
  const [toastType, setToastType] = useState("")
  const [videoDimensions, setVideoDimensions] = useState<{
    width: number;
    height: number;
  } | null>(null);
  const areaId = useSelector((state: RootState) => state.area.areaId);
  const [plateAlert, setPlateAlert] = useState("")
  const [loader, setLoader] = useState(false);

  const navigate = useNavigate()

  //get logged in user details
  useEffect(() => {
    var storedData = localStorage.getItem('userDetails');

    if (storedData) {
      var storedObject = JSON.parse(storedData);
      setUserId(storedObject[0].id)
      setAuthToken(storedObject[0].x_auth_token)
      setAuthUserID(storedObject[0].x_userid)
    }
    getExceptionReasons();
    getSamplingTestType();
    getRawMaterialType();
  }, [useEffectRequired])

  //get plate details by serial number on add exception 
  const getPlateDetailsBySerielNo = async (slNo: string) => {
    let process = ""
    if (isPlateSampling) {
      process = "plateSampling"
    } else if (isRawMaterialTest) {
      process = "sampleType"
    } else {
      process = "addException"
    }

    if (slNo !== "") {
      console.log("have slno")
      setLoader(true)
      try {
        const response = await userService.listAutoClavePlateBySerielNo(slNo, process);
        if (response.status && response.statusCode === 200) {
          try {
            // if ( Array.isArray(response.data) && response.data?.length > 0) {
            //   let rowData: any = response.data.map((element: any, index: number) => {
            //     return { 
            //         plateSerielId: element.id ,
            //         plateType: userService.getPlateStatus(parseInt(element.plate_status)) ,
            //         batchId:element.batch_number ,
            //         plateSerielNo: element.serial_number ,
            //     };
            //   });
            if (response.data && typeof response.data === 'object') {
              const statusNumber = parseInt(response.data.plate_status, 10);
              let plateStatus = userService.getPlateStatus(statusNumber);
              if (response.data.next_process_keyword === "incubation" && response.data.incubation_counter === "0") {
                  setPlateAlert("with few plates are in different activity")
              }
          
              // Function to get incubation order suffix
              const getOrdinalSuffix = (num: number): string => {
                  if (num % 100 >= 11 && num % 100 <= 13) return "th";
                  switch (num % 10) {
                      case 1: return "st";
                      case 2: return "nd";
                      case 3: return "rd";
                      default: return "th";
                  }
              };
          
              // Modify plateType based on incubation counter
              if ((statusNumber === 12 || statusNumber === 13) && response.data.incubation_counter > 0) {
                  const suffix = getOrdinalSuffix(response.data.incubation_counter);
                  plateStatus = `${response.data.incubation_counter}${suffix} ${plateStatus}`;
              }
              let rowData = [{
                plateSerielId: response.data.id,
                productionName: response.data.production_schedule_name,
                productName: response.data.product_name,
                plateType: plateStatus,
                batchId: response.data.batch_number,
                plateSerielNo: response.data.serial_number,
                current_location_id: response.data.current_location_id
              }];
              // setPlateBySerielNo(rowData);
              const uniqueUpdatedDataWithSlno = rowData.filter((newElement: any) => {
                return !plateBySerielNo.some((existingElement) => existingElement.plateSerielNo === newElement.plateSerielNo);
              });

              setPlateBySerielNo((prevUserRoleList) => [...prevUserRoleList, ...uniqueUpdatedDataWithSlno]);
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          // setPlateBySerielNo([]);
          setToastMessage(response.message);
          setToastType("error")
          setShowToast(true)
        }
      } catch (error) {
        console.error('Plate response', error);
      }finally {
      setLoader(false); // Always stop loading in finally block
    }
    } else {
      console.log("no slno")
    }
  }

  //dropdown to show the exception reason 
  const getExceptionReasons = async () => {
    try {
      const response = await userService.getExceptionReasons();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map((element: any, index: number) => {
              if (element.status === "active") {
                return {
                  id: element.id,
                  reason: element.reason,
                  status: element.status,
                };
              }
            });
            setExceptionReasons(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.error('Plate response', error);
    }
  }

  //dropdown to show the samplng test type
  const getSamplingTestType = async () => {
    try {
      const response = await userService.getSamplingTestType();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map((element: any, index: number) => {
              if (element.status === "active") {
                return {
                  id: element.id,
                  test_type: element.test_type,
                  status: element.status,
                };
              }
            });
            setSampleTestType(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.error('Plate response', error);
    }
  }

  //dropdown to show the raw material type
  const getRawMaterialType = async () => {
    try {
      const response = await userService.getRawMaterialType();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map((element: any, index: number) => {
              if (element.status === "active") {
                return {
                  id: element.id,
                  material_type: element.material_type,
                  status: element.status,
                };
              }
            });
            setRawMaterialType(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.error('Plate response', error);
    }
  }

  //dropdown to show the raw material type
  const getRawMaterialSubCtegory = async (material_id: string) => {
    try {
      const response = await userService.getRawMaterialSubCtegory(material_id);
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map((element: any, index: number) => {
              if (element.status === "active") {
                return {
                  id: element.id,
                  material_type: element.name,
                  status: element.status,
                };
              }
            });
            setRawMaterialSub(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.error('Plate response', error);
    }
  }

  //handle exception on change events 
  const handleAddExceptionChange = (e: any) => {
    const { name, value } = e.target;

    let regex;
    if (name === "remarks") {
      regex = /^[a-zA-Z][a-zA-Z0-9 ]*$/;
    } else if (name === "other_reason") {
      regex = /^[a-zA-Z][a-zA-Z0-9 ]*$/;
    }

    if (value === "") {
      // console.log("haa122")
    } else if (regex && !regex.test(value)) {
      return
    }

    setAddExceptionData((prevFormData: any) => ({
      ...prevFormData,
      [name]: value,
    }));

    if (name == 'reason_id') {
      setRawMaterialSub([])
      getRawMaterialSubCtegory(value)
    }
  };

  //handle exception alerts 
  const handleExceptionAlert = () => {
    const errors: Errors = {};
    if (plateBySerielNo.length === 0) {
      errors.scan_plate = t('exceptionHandling.errors.scanPlate');
    }
    if (!isPlateSampling && !isRawMaterialTest && !addExceptionData.remarks) {
      errors.remarks = t('exceptionHandling.errors.remark');
    }
    if (!isRawMaterialTest && !isPlateSampling && !addExceptionData.remarks) {
      errors.remarks = t('exceptionHandling.errors.remark');
    }
    if (!addExceptionData.reason_id || addExceptionData.reason_id === "select") {
      errors.reason_id = t('exceptionHandling.errors.samplingType');
    } if (!isPlateSampling && addExceptionData.reason_id === "0" && !addExceptionData.other_reason) {
      errors.other_reason = t('exceptionHandling.errors.otherReason');
    }

    if (isRawMaterialTest && (!addExceptionData.subCategory_id || addExceptionData.subCategory_id === "select")) {
    errors.subCategory_id = t('exceptionHandling.errors.subCategoryRequired');
  }

    // If there are any errors, display them to the user and disable the submit button.
    if (Object.keys(errors).length > 0) {
      console.log(errors, "errors")
      setErrors(errors);
      return;
    }
    if (isPlateSampling) {
      setPlateSamplingAlert(true)
    } else if (isRawMaterialTest) {
      setRawMaterialAlert(true)
    } else {
      setShowAddExceptionAlert(true)
    }
    setErrors({});
  }

//handle exception submit api call 
const handleExceptionSubmit = async () => {
const dataToSend = {
  "user_id": userId,
  "plate_ids": plateBySerielNo.map((plate: any) => plate.plateSerielId).join(','),
  "area_id": areaId ? areaId : "0",
  //"area_id": plateBySerielNo[0]?.current_location_id,
  "remarks": addExceptionData.remarks,
  "reason_id": addExceptionData.reason_id,
  "other_reason": addExceptionData.other_reason,
  "interface_name": "Add Exception"
}

try {
  const response = await userService.addPlateException(dataToSend, authToken, authUserID);
  if (response.status && response.statusCode === 200) {
        setUseEffectRequired(true)
        setToastType("success")
        setToastMessage(response.message)
      } else {
        setToastType("error")
        setToastMessage(response.message)
      }
      if (setRefreshPage) {
        setRefreshPage();
      }
      setShowModel()
      setShowAddExceptionAlert(false)
      setShowToast(true)
      setPlateBySerielNo([])
      setErrors({})
      setPlateAlert("")
    } catch (error) {
      console.error('Plate response', error);
    }
    // setUseEffectRequired(true)
    // setShowModel()
    // setShowAddExceptionAlert(false)
    // setShowToast(true)
    // setPlateBySerielNo([])
    // setErrors({})


    setAddExceptionData({
      remarks: "",
      reason_id: "",
      other_reason: "",
      user_id: 0,
      area_id: "",
      subCategory_id: ""
    });
  }

  //handle plate sampling submit api call 
  const handlePlateSamplingSubmit = async () => {
    const dataToSend = {
      "user_id": userId,
      "plate_ids": plateBySerielNo.map((plate: any) => plate.plateSerielId).join(','),
      "test_type": addExceptionData.reason_id,
      "interface_name": "Add Plate Sampling"
    }

    try {
      const response = await userService.assignSamplingPlates(dataToSend);
      if (response.status && response.statusCode === 200) {
        setUseEffectRequired(true)
        setToastType("success")
        setToastMessage(response.message)
        setShowToast(true)
        addExceptionClose()
        setPlateSamplingAlert(false)
        // navigate("/scanArea")
      } else {
        setToastType("error")
        setToastMessage(response.message)
        setShowToast(true)
        // addExceptionClose()
        // setPlateSamplingAlert(false)

      }
      // setShowModel()
      // setPlateSamplingAlert(false)
      // setShowToast(true)
      // addExceptionClose()
      // setPlateBySerielNo([])
      // setErrors({})
    } catch (error) {
      console.error('Plate response', error);
    }
  }

  //handle rawmaterial test submit api call 
  const handleRawMaterialTestSubmit = async () => {
    const dataToSend = {
      "user_id": userId,
      "plate_ids": plateBySerielNo.map((plate: any) => plate.plateSerielId).join(','),
      "raw_material_type": addExceptionData.reason_id,
      "raw_material_sub_type": addExceptionData.subCategory_id,
      "interface_name": "Add Raw Material"
    }

    try {
      const response = await userService.assignRawMaterialTest(dataToSend);
      if (response.status && response.statusCode === 200) {
        setUseEffectRequired(true)
        setToastType("success")
        setToastMessage(response.message)
        setShowToast(true)
        addExceptionClose()
        setRawMaterialAlert(false)
      } else {
        setToastType("error")
        setToastMessage(response.message)
        setShowToast(true)
        addExceptionClose()
        setRawMaterialAlert(false)

      }
      // setShowModel()
      // setPlateSamplingAlert(false)
      // setShowToast(true)
      // addExceptionClose()
      // setPlateBySerielNo([])
      // setErrors({})
    } catch (error) {
      console.error('Plate response', error);
    }
  }

  //on close the add exception modal 
  const addExceptionClose = () => {
    setShowModel()
    setPlateBySerielNo([])
    setErrors({})
    setAddExceptionData({
      remarks: "",
      reason_id: "",
      other_reason: "",
      user_id: 2,
      area_id: "",
      subCategory_id: ""
    });
    setPlateAlert("")
  }

  //handle error in the webcam scan 
  const webCamError = (error: any) => {
    console.log(error);
  };

  //handle scanned result from webcam 
  const webCamScan = (result: any) => {
    if (result) {
      const scanData = JSON.parse(result);
      setWebCamResult(result);
      setShowScan(false);
      closeCamera();
      if (scanData?.serial_number) {
        setToastMessage(t('exceptionHandling.plateScanSuccess'));
        setToastType("success");
      } else {
        setToastMessage(t('exceptionHandling.plateScanFailed'));
        setToastType("error");
      }
      setShowToast(true)
      getPlateDetailsBySerielNo(scanData?.serial_number)
    }
  };

  //handle modal open for qr scan 
  const handleModalOpen = () => {
    setWebCamResult("");
    setShowScan(true);
    openCamera();
  };

  //activate the camera to capture the qr value 
  const openCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
      });
      const track = stream.getVideoTracks()[0];

      if (track) {
        const settings = track.getSettings();
        const width = settings.width || 0;
        const height = settings.height || 0;
        setVideoDimensions({ width, height });
        setStream(true);
      } else {
        console.error("Video track not found.");
      }
    } catch (error) {
      console.error(error);
    }
  };

  //on closing webcam modal 
  const closeCamera = () => {
    // Access the MediaStream from the video element
    const videoElement = document.querySelector('video');
    const mediaStream = videoElement?.srcObject;

    if (mediaStream instanceof MediaStream) {
      // Get the tracks and stop them if the mediaStream exists
      const tracks = mediaStream.getTracks();

      tracks.forEach((track) => track.stop());

      // Close the camera
      setStream(false);
    } else {
      console.error("Video element or media stream not found.");
    }
  };

  return (
    <div>
      <CustomToast
        show={showToast}
        onClose={() => setShowToast(false)}
        delay={5000}
        message={toastMessage}
        toastType={toastType}
      // toastPosition='topLeft'
      />
      {loader && <CustomLoader />}

      {/* add exception modal */}
      <AddExceptionModel
        show={showModel}
        plateBySerielNo={plateBySerielNo}
        setPlateBySerielNo={setPlateBySerielNo}
        errors={errors}
        addExceptionData={addExceptionData}
        exceptionReasons={exceptionReasons}
        samleTestType={samleTestType}
        rawMaterialType={rawMaterialType}
        rawMaterialSub={rawMaterialSub}
        addExceptionClose={addExceptionClose}
        getPlateDetailsBySerielNo={getPlateDetailsBySerielNo}
        handleModalOpen={handleModalOpen}
        handleAddExceptionChange={handleAddExceptionChange}
        handleExceptionAlert={handleExceptionAlert}
        isPlateSampling={isPlateSampling}
        isRawMaterialTest={isRawMaterialTest}
        showToast={showToast}
        setShowToast={setShowToast}
        setToastMessage={setToastMessage}
        setToastType={setToastType}
        toastMessage={toastMessage}
        toastType={toastType}
        loading={loader}
      />

      {/* scan area model */}
      <ScanAreaModel
        show={showScan}
        onHide={() => setShowScan(false)}
        webCamError={webCamError}
        webCamScan={webCamScan}
      />

      {/* Alert modal for Add Exception */}
      <AlertModal
        show={showAddExceptionAlert}
        onHide={() => setShowAddExceptionAlert(false)}
        title={t("common.alert")}
        message={`${t('exceptionHandling.addPlateException')} ${plateAlert} `}
        onConfirm={handleExceptionSubmit}
      />

      {/* Alert modal for Add Plate Sampling */}
      <AlertModal
        show={showPlateSamplingAlert}
        onHide={() => setPlateSamplingAlert(false)}
        title={t("common.alert")}
        message={t('exceptionHandling.addPlateSampling')}
        onConfirm={handlePlateSamplingSubmit}
      />

      {/* Alert modal for raw material test */}
      <AlertModal
        show={showRawMaterialAlert}
        onHide={() => setRawMaterialAlert(false)}
        title={t("common.alert")}
        message={t('exceptionHandling.addRawMaterial')}
        onConfirm={handleRawMaterialTestSubmit}
      />
    </div>
  )
}

export default AddException;